const appendParam = (urlString, pair) =>
	urlString === '' ? pair : `${urlString}&${pair}`;

const buildArrayParam = (key, value) => {
	const items = value
		.filter((v) => typeof v === 'string')
		.filter((v) => v.length > 0);

	// Single-item arrays use bracket notation so parsers treat them as arrays
	if (items.length === 1) return `${key}[]=${encodeURIComponent(items[0])}`;

	// Multiple items: creates multiple instances of the key (e.g. amenities=a&amenities=b)
	return items.map((v) => `${key}=${encodeURIComponent(v)}`).join('&');
};

const buildSearchLink = (params, prefix) => {
	const sortedKeys = Object.keys(params).sort((a, b) => a.localeCompare(b));

	const urlString = sortedKeys.reduce((acc, key) => {
		const value = params[key];

		// Skip page=1 so first page URLs are canonical without querystring
		if (key === 'page' && (value === 1 || value === '1')) return acc;

		// Handle arrays: skip empty arrays entirely to avoid appending "key=" with no value
		if (Array.isArray(value)) {
			if (!value.length) return acc;
			const arrayParam = buildArrayParam(key, value);
			return arrayParam ? appendParam(acc, arrayParam) : acc;
		}

		// Prevents appending null/undefined values
		if (value)
			return appendParam(acc, `${key}=${encodeURIComponent(value)}`);

		return acc;
	}, '');

	return `${prefix ? '/search' : ''}?${urlString}`;
};

export default buildSearchLink;
